import cx from 'classnames';
import styles from '../../styles/common/table.scss';
import searchStyles from '../../styles/search.scss';
import { makeid } from '../../constants';

interface Items {
  isActive: boolean;
  rowItems: any[];
  onRowClick: () => void;
}

interface Props {
  items: Items;
  active: boolean;
  rowHeight?: string;
}

const TableRowItem = (props: Props) => {
  const { items, active, rowHeight } = props;
  const { rowItems, onRowClick } = items;
  return (
    <div
      className={cx(
        'row lil-flex',
        {
          [styles.active]: active,
          active,
          [styles['main-row']]: true,
        },
        'main-row'
      )}
      onClick={onRowClick}
    >
      {rowItems.map(item => (
        <div
          style={{ minHeight: rowHeight || '59px' }}
          className={cx(
            item.className,
            'columns',
            styles.columns,
            searchStyles.columns
          )}
          key={makeid()}
        >
          {item.component}
        </div>
      ))}
    </div>
  );
};

export default TableRowItem;



// WEBPACK FOOTER //
// ./components/search/tableRowItem.tsx